var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccessionBlue = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1772_567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1772_567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9375 49.2187C30.668 49.2187 28.5352 48.7881 26.5391 47.9267C24.543 47.0654 22.8066 45.8965 21.3301 44.4199C19.8535 42.9433 18.6846 41.207 17.8232 39.2109C16.9619 37.2148 16.5312 35.082 16.5312 32.8125C16.5312 30.5429 16.9619 28.4101 17.8232 26.414C18.6846 24.4179 19.8535 22.6816 21.3301 21.205C22.8066 19.7285 24.543 18.5595 26.5391 17.6982C28.5352 16.8369 30.668 16.4062 32.9375 16.4062C35.207 16.4062 37.3398 16.8369 39.3359 17.6982C41.332 18.5595 43.0684 19.7285 44.5449 21.205C46.0215 22.6816 47.1904 24.4179 48.0518 26.414C48.9131 28.4101 49.3438 30.5429 49.3438 32.8125C49.3438 35.082 48.9131 37.2148 48.0518 39.2109C47.1904 41.207 46.0215 42.9433 44.5449 44.4199C43.0684 45.8965 41.332 47.0654 39.3359 47.9267C37.3398 48.7881 35.207 49.2187 32.9375 49.2187ZM32.9375 45.9375C36.6016 45.9375 39.7051 44.666 42.248 42.123C44.791 39.58 46.0625 36.4765 46.0625 32.8125C46.0625 31.0625 45.7344 29.3808 45.0781 27.7675C44.4219 26.1543 43.4785 24.7324 42.248 23.5019L32.9375 32.8125V19.6875C29.2734 19.6875 26.1699 20.959 23.627 23.5019C21.084 26.0449 19.8125 29.1484 19.8125 32.8125C19.8125 36.4765 21.084 39.58 23.627 42.123C26.1699 44.666 29.2734 45.9375 32.9375 45.9375Z",
    fill: "#455CC7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccessionBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accession-blue.a9c421ad.svg";
export { ForwardRef as ReactComponent };